import {FC} from 'react'
import {Assessment, Questionstatus} from '../../core/_models'

type Props = {
  category: Assessment
}

const QuestionsStatusCell: FC<Props> = ({category}) => {
  let look: string = 'light-primary'
  switch (category.status_name) {
    case Questionstatus.active.value:
      look = 'light-success'
      break
    case Questionstatus.inactive.value:
      look = 'light-secondary text-dark'
      break
  }

  return (
    <>
      {category && (
        <div className={`badge badge-${look} fw-bolder`}>
          {category.status_name.charAt(0).toUpperCase() + category.status_name.slice(1)}
        </div>
      )}
    </>
  )
}

export {QuestionsStatusCell}
